import React from "react";
import { UserCheck, Share2 } from "lucide-react";

/**
 * Renders inline badges on a reply when it included an Assign-To or Forward-To
 * action. Resolves user/team labels from the provided reference data so we never
 * show raw UUIDs.
 *
 * Props:
 *  - reply: the reply doc (carries assigned_user_id_change / team_id_change)
 *  - referenceData: from useRefData() — provides users + teams lists
 */
export default function ReplyAssignTimelineBadges({ reply, referenceData }) {
  if (!reply) return null;
  const userChange = reply.assigned_user_id_change;
  const teamChange = reply.team_id_change;
  if (!userChange && !teamChange) return null;

  const users = referenceData?.users || [];
  const teams = referenceData?.teams || [];
  const userLabel = userChange
    ? (users.find((u) => u.value === userChange)?.label || "an associate")
    : null;
  const teamLabel = teamChange
    ? (teams.find((t) => t.value === teamChange)?.label || "another team")
    : null;

  return (
    <div className="mb-2 flex flex-wrap items-center gap-2">
      {userChange && (
        <span
          className="inline-flex items-center gap-1.5 text-[11px] px-2 py-0.5 rounded-full border bg-sky-500/10 text-sky-300 border-sky-500/20"
          data-testid="reply-badge-assigned"
        >
          <UserCheck className="w-3 h-3" />
          Assigned to <span className="font-medium text-white">{userLabel}</span>
        </span>
      )}
      {teamChange && (
        <span
          className="inline-flex items-center gap-1.5 text-[11px] px-2 py-0.5 rounded-full border bg-violet-500/10 text-violet-300 border-violet-500/20"
          data-testid="reply-badge-forwarded"
        >
          <Share2 className="w-3 h-3" />
          Forwarded to <span className="font-medium text-white">{teamLabel}</span>
          <span className="text-zinc-500">· assignee cleared</span>
        </span>
      )}
    </div>
  );
}
